<template>
  <div>
    <div class="battery-order-history-view__container battery-order-history-view__container--history">
      <div class="battery-order-view__row battery-order-view__row--title">
        Order History
      </div>
      <div class="battery-order-view__container battery-order-view__container--order" v-if="orders.length">
        <OrderHeader></OrderHeader>
        <Order v-for="(order, index) in orders" :index="index" :key="index" :order="order"></Order>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import DataMethods from '../utils/DataMethods.js';
  import Order from './orders/Order.vue';
  import OrderHeader from './orders/OrderHeader.vue';

  export default {
    name: 'BatteryOrdeHistoryView',
    mixins: [DataMethods],
    components: {
      Order,
      OrderHeader,
    },
    computed: {
      ...mapGetters('batteryStore', ['loaders', 'orders']),
    },
  };
</script>
